import { API } from "../../config/axiosConfig";

export const registerUser = (data) => {
  return API.post("/auth/signup", data);
};

export const loginUser = (data) => API.post("/auth/login", data);

export const logoutUser = () => {
  return API.get("/auth/logout");
};
export const profileUpdate = (token, data) => {
  return API.put("/user", data);
};
export const currentProfile = (token) => {
  return API.get("/user");
};
